/**
 * Single-price cost label for extending an expired invitation (PQ-07).
 * A partner/wallet user pays from their wallet; an individual pays in publish credits.
 */
export function extendCostLabel(isWalletUser: boolean): string {
  return isWalletUser ? '₹500 from your wallet' : '2 publish credits';
}
